"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import { betslipApi } from "fansunited-frontend-components";
import { useTenantSettings } from "@/lib/tenant/TenantSettingsProvider";
import { getOutcomeFromScores } from "./score-to-outcome";
import { recordKickoff } from "./persistence";
import { useBetslipGeoBlocked } from "./BetslipGeoContext";
import type { BetslipMarket } from "./types";
export interface UseBetslipReturn {
  addPrediction(matchId: string, homeScore: number, awayScore: number, kickoffAt?: string): void;
  addOddsSelection(matchId: string, market: BetslipMarket, outcome: string, kickoffAt?: string): void;
  removeSelection(id: string): void;
  canAddPredictions: boolean;
  canAddOdds: boolean;
}

/**
 * Public hook for pushing selections into the Fans United Betslip widget.
 * Thin wrapper over `betslipApi.setSelection` that applies canvas-side
 * mode gating, geoblock gating, and score-to-outcome mapping.
 */
export function useBetslip() {
  const $ = _c(3);
  const settings = useTenantSettings();
  const isGeoBlocked = useBetslipGeoBlocked();
  settings.betslip?.mode;
  const mode = settings.betslip?.mode ?? "disabled";
  const featureEnabled = settings.features.betslip !== "disabled";
  const canAddPredictions = featureEnabled && mode !== "disabled" && !isGeoBlocked;
  const canAddOdds = featureEnabled && mode === "predictions-and-odds" && !isGeoBlocked;
  let t0;
  if ($[0] !== canAddOdds || $[1] !== canAddPredictions) {
    t0 = {
      canAddPredictions,
      canAddOdds,
      addPrediction(matchId, homeScore, awayScore, kickoffAt) {
        if (!canAddPredictions) {
          return;
        }
        const outcome = getOutcomeFromScores(homeScore, awayScore);
        const id = `${matchId}:FT_1X2:${outcome}`;
        recordKickoff(id, kickoffAt);
        betslipApi.setSelection(id);
      },
      addOddsSelection(matchId_0, market, outcome_0, kickoffAt_0) {
        if (!canAddOdds) {
          return;
        }
        const id_0 = `${matchId_0}:${market}:${outcome_0}`;
        recordKickoff(id_0, kickoffAt_0);
        betslipApi.setSelection(id_0);
      },
      removeSelection(id_1) {
        betslipApi.removeSelection(id_1);
      }
    };
    $[0] = canAddOdds;
    $[1] = canAddPredictions;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}